export default __webpack_public_path__ + "static/media/Group 953.24c645ea.png";